import React from 'react';
import { Link } from 'react-router-dom';

function Terms() {
    return (
        <div className="terms">
            <div className="container">
                <h1>Terms and Conditions</h1>

                <h2>Introduction</h2>
                <p>Welcome to the Kano State Ministry of Youth and Sports Development Registration Portal. By registering with us, you agree to comply with and be bound by the following terms and conditions. Please review these terms carefully.</p>

                <h2>Purpose of Registration</h2>
                <p>The registration process with the Kano State Ministry of Youth and Sports Development is designed to provide opportunities for empowerment and job placements to the youth of Kano State. By registering, you become part of a database that enables you to benefit from various programs, initiatives, and job opportunities facilitated by the Ministry.</p>

                <h2>Benefits of Registration</h2>
                <p><strong>Empowerment Programs:</strong> Gain access to a variety of empowerment programs aimed at enhancing your skills and employability.</p>
                <p><strong>Job Opportunities:</strong> Be the first to know about job openings and placement opportunities within Kano State and with our partner organizations.</p>
                <p><strong>Secure Data Management:</strong> Your data is securely managed and used solely for the purposes of the Ministry’s initiatives.</p>

                <h2>Accuracy of Information</h2>
                <p>All information provided during the registration process must be accurate and complete. Providing false or misleading information can result in disqualification from the programs and opportunities offered by the Ministry.</p>

                <h2>Data Protection</h2>
                <p>We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable physical, electronic, and managerial procedures to safeguard and secure the information we collect online.</p>

                <h2>Use of Information</h2>
                <p>The information you provide during registration will be used for the following purposes:</p>
                <ul>
                    <li>To verify your identity and eligibility for programs and job opportunities.</li>
                    <li>To match you with suitable empowerment programs and job placements.</li>
                    <li>To communicate with you regarding updates, new opportunities, and other relevant information.</li>
                </ul>

                <h2>Consent</h2>
                <p>By registering with the Kano State Ministry of Youth and Sports Development, you consent to the use of your personal data for the purposes outlined in these Terms and Conditions. You also agree to be contacted by the Ministry via email, phone, or SMS regarding your registration and related opportunities.</p>

                <h2>Changes to Terms</h2>
                <p>The Kano State Ministry of Youth and Sports Development reserves the right to update or change these terms and conditions at any time. Any changes will be posted on this page, and it is your responsibility to review this page periodically for updates.</p>

                <h2>Governing Law</h2>
                <p>These terms and conditions are governed by the laws of Kano State, Nigeria. Any disputes arising out of or relating to these terms shall be subject to the exclusive jurisdiction of the courts of Kano State.</p>

                <h2>Contact Us</h2>
                <p>If you have any questions about these terms and conditions, please contact us at:</p>
                <p>Kano State Ministry of Youth and Sports Development<br />
                    N0 1 Commisioner Road opposite Ministry of works, Kano State Nigeria.<br /><br />
                    <a href="mailto:youthsandsportsportal@gmail.com">youthsandsportsportal@gmail.com</a>
                </p>
                <hr></hr>

                <div className="footer">
                    <a href="https://techlife.ng">© 2024 All Rights Reserved. Developed By Techlife.</a>
                </div>
            </div>
        </div>
    );
}

export default Terms;
